export function formatFieldValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '—'
  }
  if (typeof value === 'object') {
    return JSON.stringify(value, null, 2)
  }
  return String(value)
}

export function valuesDiffer(platform: unknown, carrier: unknown): boolean {
  return JSON.stringify(platform) !== JSON.stringify(carrier)
}
